module.exports = __webpack_public_path__ + "static/media/others.f4266d9c.svg";